import { apiRequest } from './httpClient';

export const getMemberCalendarConnection = () => apiRequest('getMemberCalendarConnection', {
  method: 'GET',
});

export const startMemberCalendarOAuth = () => apiRequest('startMemberCalendarOAuth', {
  method: 'POST',
});

export const disconnectMemberCalendar = () => apiRequest('disconnectMemberCalendar', {
  method: 'POST',
});

export const syncMyMemberCalendarEvents = () => apiRequest('syncMyMemberCalendarEvents', {
  method: 'POST',
});
